import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import SearchPage, { Props } from "../components/search/SearchPage";
import { SEARCH_TYPES } from "../components/search/SearchPage";
import { parse } from "qs";
import PageProps from "../lib/models/pageProps";

export const RESULT_PAGE_LIMIT = 15;
export const RESULT_DOCUMENT_LIMIT = 20;
export default function Page(props: Props) {
  return <SearchPage {...props} />;
}

Page.getInitialProps = async ({
  query
}: InitialPropsContext): PageProps<Props> => {
  const {
    q: searchTerm = "",
    tab: activeTab = SEARCH_TYPES[0].id,
    page: dirtyPage = 1,
    segments
  } = query;
  const page = Number(dirtyPage);

  const checkedSegments =
    segments && Object.values(parse(String(segments)) as string[]);

  if (!searchTerm) {
    return {
      activeTab: String(activeTab),
      searchTerm: String(searchTerm),
      page: 1,
      checkedSegments
    };
  }

  return {
    activeTab: String(activeTab),
    searchTerm: String(searchTerm),
    page,
    checkedSegments
  };
};
